/** @jsxImportSource @emotion/react */
import { EmailTemplateTypeEnum } from '__generatedTypes__/globalTypes'
import { CommonEmail } from '../CommonEmail'

export const PasswordReset = () => <CommonEmail type={EmailTemplateTypeEnum.PasswordReset} />
